import axios from 'axios';
import JSZip from "jszip";
import { Frame } from '@/types/frame';
import { Template, TemplateResponse } from '@/types/template';
class FrameSerivce {
    public async generateLayoutsSuggestions(frame: Frame): Promise<Frame | null> {
        if (frame === null) {
            return null; 
        }
    
        const formData = new FormData();
        formData.append('content', frame.content); 
    
        try {
            const response = await axios.post(
                process.env.VUE_APP_BACKEND_FLASK + 'latizes/frame/generate/layouts',
                formData,
                {responseType: 'blob'}
            );
    
            const zip = await JSZip.loadAsync(response.data);
    
            const pdfBlob = await zip.file('presentation.pdf')!.async('blob');
            const sectionsText = await zip.file('template.json')!.async('text');
            const parsedTemplate = JSON.parse(sectionsText) as TemplateResponse;
            
            const template: Template = {
                pdfSource: parsedTemplate.pdfSource,
                slideTemplate: Object.fromEntries(
                  Object.entries(parsedTemplate.slideTemplate).map(([k, v]) => [parseInt(k)+1, v])
                )
              };

            if (template === null) {
                return null; 
            }
            frame.isGenerated = true;
            frame.isReplaced = false;
            frame.template = template; 
            frame.template!.pdfSource = URL.createObjectURL(pdfBlob);

            return frame; 
        } catch (error) {
            console.error("Fehler beim Generieren der Layoutvorschläge:", error);
            return null; 
        }
    }

}
export const frameService = new FrameSerivce();

